export const getNotificationSelector = (state) => state.get('notification');
